import {
  Avatar,
  Box,
  Button,
  Grid,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import { grey } from '@mui/material/colors';
import * as React from 'react';
import * as Redux from 'react-redux';
import {
  BLACK_COLOR,
  BLUE_COLOR,
  PURPLE_COLOR,
  WHITE_COLOR,
  notaColor,
  notaHoverColor,
} from '../../../../../constants/ColorsConst';
import * as CONST from '../../../../../constants/FieldsConst';
import { dateformat, notaToPonderacionHelper } from '../../../../../helpers';
import { useNotification } from '../../../../../helpers/Notification';
import {
  ActionsListWidget,
  LoadingWidget,
  ModalComponent,
} from '../../../../../widgets';
import { getFilesArchivos } from '../../../../archivos/HelpersArchivos';
import BotonComponent from '../../../../dashboard/components/BotonNuevo';
import { saveNotasEvaluativasAction } from '../NotasEvaluativasAction';
import {
  CALCULADORA_NOTAS_EVALUATIVAS,
  PARAMS_NOTAS_EVALUATIVAS,
} from '../NotasEvaluativasReducer';
import CalculadoraNotasEstudianteView from './CalculadoraNotasEstudianteView';
import ColumnChartNotasEvaluativas from './ColumnChartNotasEvaluativas';
import FieldNotaEstudiante from './FieldNotaEstudiante';
import PieChartNotasEvlauativas from './PieChartNotasEvaluativas';

const ListadoNotasEvaluativas = ({ isGraficos }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const docentesStore = Redux.useSelector((state) => state.docentes);
  const estudiantesStore = Redux.useSelector((state) => state.estudiantes);
  const notasEvaluativasStore = Redux.useSelector(
    (state) => state.notasEvaluativas,
  );
  const planEvaluacionStore = Redux.useSelector(
    (state) => state.planEvaluacion,
  );

  const [actividadesArray, setActividadesArray] = React.useState([]);
  const [notaActiva, setNotaActiva] = React.useState(null);
  const [planEvaluacion, setPlanEvaluacion] = React.useState(null);
  const [loadingSave, setLoadingSave] = React.useState(false);
  const [openModalForm, setOpenModalForm] = React.useState(false);

  const [estudianteSelect, setEstudianteSelect] = React.useState(false);

  React.useEffect(() => {
    const handleEsc = (event) => onEscape(event);
    window.addEventListener('keydown', handleEsc);

    const payload = {
      ...notasEvaluativasStore.params,
      idEntidad: entidadesStore.activo.id,
      idPeriodoAcademico: entidadesStore.ajustes.periodoAcademico.id,
      idDocente: loginStore.isTeacher ? docentesStore.activo.id : null,
    };
    dispatch({ type: PARAMS_NOTAS_EVALUATIVAS, payload });

    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    let actividades = [];
    if (planEvaluacionStore.all.length > 0) {
      setPlanEvaluacion(planEvaluacionStore.all[0]);
      planEvaluacionStore.all[0].temas.forEach((t) => {
        t.evaluaciones.forEach((e) => {
          e.instrumentos.forEach((i) => {
            actividades.push(i);
          });
        });
      });
    }
    setActividadesArray(actividades);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planEvaluacionStore.all]);

  async function onSave() {
    if (!notaActiva.actividad.notaEvaluativa.nota) {
      setLoadingSave(false);
      return notify('Falta asignar la nota', { warning: true });
    }

    setLoadingSave(true);
    const res = await saveNotasEvaluativasAction(
      {
        dispatch,
        notify,
      },
      notaActiva.actividad.notaEvaluativa?.id,
      {
        idDocente: notasEvaluativasStore.params.idDocente,
        idEstudiante: notaActiva.idEstudiante,
        idPtevaInstrumento: notaActiva.actividad.id,
        nota:
          notaActiva.actividad.notaEvaluativa.nota.length === 1
            ? `0${notaActiva.actividad.notaEvaluativa.nota}`
            : notaActiva.actividad.notaEvaluativa.nota,
      },
      notasEvaluativasStore.params,
    );
    if (res) {
      setNotaActiva(null);
      setLoadingSave(false);
    }
  }

  function notasEvaluativasByPlan(notasEvaluativas) {
    const notas = actividadesArray.map((actividad) => {
      const nota = notasEvaluativas.find(
        (el) => el.ptevaInstrumento.id === actividad.id,
      );

      return {
        id: actividad.id,
        ponderacion: actividad.ponderacion,
        notaEvaluativa: nota
          ? {
              id: nota.id,
              nota: nota?.nota,
            }
          : null,
      };
    });

    return notas;
  }

  function actividadesExtrasByPlan(actividadesExtras) {
    if (!planEvaluacion) {
      // notify('Falta el plan de evaluacion');
      return [];
    }

    const res = planEvaluacion.actividadesExtras.map((actExtra) => {
      const actividad = actividadesExtras.find(
        (el) => el.actividadExtra.id === actExtra.id,
      );

      return {
        id: actExtra.id,
        ponderacion: actividad?.actividadExtra.ponderacion,
        notaEvaluativa: actividad
          ? {
              id: actividad.id,
              nota: actividad?.nota,
            }
          : null,
      };
    });

    return res;
  }

  function celdasNotas(idEstudiante, actividad) {
    return (
      <TableCell align="center">
        {!actividad.notaEvaluativa ||
        (notaActiva &&
          notaActiva.idEstudiante === idEstudiante &&
          notaActiva.actividad.id === actividad.id) ? (
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            justifyContent="center"
          >
            <Box sx={{ backgroundColor: 'white' }}>
              <FieldNotaEstudiante
                id={`${idEstudiante}-${actividad.id}-${CONST.nota.name}`}
                onKeyDown={handleKeyDown}
                nota={
                  idEstudiante === notaActiva?.idEstudiante &&
                  notaActiva?.actividad.id === actividad.id
                    ? notaActiva?.actividad.notaEvaluativa.nota
                    : '0'
                }
                onChange={(text) => {
                  setNotaActiva({
                    idEstudiante,
                    actividad: {
                      id: actividad.id,
                      notaEvaluativa: {
                        id: actividad.notaEvaluativa?.id,
                        nota: text,
                      },
                    },
                  });
                }}
              />
            </Box>
            <BotonComponent
              icon
              tooltip="Guardar"
              saveIcon
              colorIcon={BLACK_COLOR}
              click={onSave}
            />
          </Stack>
        ) : (
          <Stack alignItems="center">
            <Typography
              textAlign="center"
              sx={{ fontSize: '14pt', fontWeight: 'bold' }}
            >
              {notaToPonderacionHelper(
                parseInt(actividad.notaEvaluativa.nota),
                actividad.ponderacion,
                entidadesStore.ajustes.ponderacion,
              ).toFixed(2)}{' '}
              <label style={{ fontSize: '10pt', fontWeight: 'normal' }}>
                Pts
              </label>
            </Typography>
            <Button
              size="small"
              sx={{
                minWidth: '50%',
                fontSize: '14pt',
                p: '0px',
                color: WHITE_COLOR,
                fontWeight: 'bold',
                backgroundColor: notaColor(
                  parseInt(actividad.notaEvaluativa.nota),
                ),
                '&:hover': {
                  color: WHITE_COLOR,
                  backgroundColor: notaHoverColor(
                    parseInt(actividad.notaEvaluativa.nota),
                  ),
                },
              }}
              onClick={() => {
                setNotaActiva({ idEstudiante, actividad });
              }}
            >
              {Number(actividad.notaEvaluativa.nota) < 10
                ? '0' + actividad.notaEvaluativa.nota.replace('0', '')
                : actividad.notaEvaluativa.nota}
            </Button>
          </Stack>
        )}
      </TableCell>
    );
  }

  function celdasActividadExtra(actividad) {
    return (
      <TableCell align="center">
        {
          <>
            <Typography
              textAlign="center"
              sx={{ fontSize: '14pt', fontWeight: 'bold' }}
            >
              {actividad.notaEvaluativa
                ? notaToPonderacionHelper(
                    parseInt(actividad.notaEvaluativa?.nota),
                    actividad.ponderacion,
                    entidadesStore.ajustes.ponderacion,
                  ).toFixed(2)
                : '0.00'}{' '}
              <label style={{ fontSize: '10pt', fontWeight: 'normal' }}>
                Pts
              </label>
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: notaHoverColor(parseInt(actividad.notaEvaluativa?.nota)),
                fontWeight: 'bold',
                fontSize: '18pt',
              }}
            >
              {actividad?.notaEvaluativa?.nota ?? '0'}
            </Typography>
          </>
        }
      </TableCell>
    );
  }

  const tablaChart = actividadesArray.length > 0 && isGraficos && (
    <Table size="small" aria-label="a dense table">
      <TableHead>
        <TableRow>
          <TableCell sx={{ width: '40%' }}>
            <PieChartNotasEvlauativas
              actividadesArray={actividadesArray}
              estudiantes={estudiantesStore.allEstudiantesNotas}
            />
          </TableCell>
          <TableCell sx={{ width: '60%' }}>
            <Box>
              <ColumnChartNotasEvaluativas
                actividadesArray={actividadesArray}
                estudiantes={estudiantesStore.allEstudiantesNotas}
              />
            </Box>
          </TableCell>
        </TableRow>
      </TableHead>
    </Table>
  );

  function onEscape(event) {
    if (event.key === 'Escape' && notaActiva) setNotaActiva(null);
  }
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') onSave();
    onEscape(event);
  };

  const tableHeader = (
    <TableHead>
      <TableRow>
        <TableCell sx={{ width: '20%' }}>
          <Typography sx={{ fontWeight: 'bold', fontSize: '14pt' }}>
            ESTUDIANTES
          </Typography>
        </TableCell>
        {actividadesArray.map((a) => {
          return (
            <TableCell
              align="center"
              sx={{
                verticalAlign: 'top',
                maxWidth: '160px',
                minWidth: '160px',
              }}
            >
              <Stack justifyContent="space-evenly">
                <Typography
                  align="center"
                  sx={{ fontWeight: 'bold', fontSize: '14pt' }}
                >
                  {dateformat(a.fechaInicio, { inverse: true })}
                </Typography>
                <Tooltip
                  describeChild
                  title={a.instrumento.nombre}
                  placement="top"
                >
                  <Typography
                    variant="subTitle1"
                    align="center"
                    sx={{
                      height: '25px',
                      textOverflow: 'ellipsis',
                      overflow: 'hidden',
                    }}
                  >
                    {a.instrumento.nombre}
                  </Typography>
                </Tooltip>
                <Typography
                  align="center"
                  sx={{ fontWeight: 'bold', fontSize: '14pt' }}
                >
                  {a.ponderacion} Pts
                </Typography>
              </Stack>
            </TableCell>
          );
        })}
        {planEvaluacion?.actividadesExtras.length > 0
          ? planEvaluacion.actividadesExtras.map((a) => {
              return (
                <TableCell
                  align="center"
                  sx={{
                    verticalAlign: 'top',
                    maxWidth: '160px',
                    minWidth: '160px',
                  }}
                >
                  <Stack justifyContent="space-evenly">
                    <Typography
                      align="center"
                      sx={{ fontWeight: 'bold', fontSize: '14pt' }}
                    >
                      {dateformat(a.fechaInicio, { inverse: true })}
                    </Typography>
                    <Tooltip
                      describeChild
                      title={a.instrumento?.nombre ?? '-'}
                      placement="top"
                    >
                      <Typography
                        variant="caption"
                        align="center"
                        sx={{
                          height: '50px',
                          textOverflow: 'ellipsis',
                          overflow: 'hidden',
                        }}
                      >
                        {a.instrumento?.nombre ?? '-'}
                      </Typography>
                    </Tooltip>
                    <Typography
                      align="center"
                      sx={{ fontWeight: 'bold', fontSize: '14pt' }}
                    >
                      {a.ponderacion} Pts
                    </Typography>
                    <Box
                      sx={{
                        backgroundColor:
                          a.tipo === 'REMEDIAL' ? PURPLE_COLOR : BLUE_COLOR,
                        color: WHITE_COLOR,
                        borderRadius: '30px',
                      }}
                    >
                      <Typography
                        align="center"
                        sx={{ fontWeight: 'bold', fontSize: '10pt' }}
                      >
                        {a.tipo}
                      </Typography>
                    </Box>
                  </Stack>
                </TableCell>
              );
            })
          : null}

        <TableCell align="center">
          <Box sx={{ minWidth: '80px' }}>
            <Typography
              textAlign="center"
              sx={{ fontSize: '16pt', fontWeight: 'bold' }}
            >
              DEF.
            </Typography>
          </Box>
        </TableCell>
      </TableRow>
    </TableHead>
  );

  const tablaBody = (
    <TableContainer component={Paper}>
      <Table size="small" aria-label="a dense table">
        {tableHeader}
        <TableBody>
          {estudiantesStore.allEstudiantesNotas.map((est) => {
            let totalDef = 0;

            if (est.notasEvaluativas.length > 0) {
              est.notasEvaluativas.forEach((nota) => {
                const actividad = actividadesArray.find(
                  (a) => a.id === nota.ptevaInstrumento.id,
                );

                {
                  /* let actividadExtra;
                if (est.actividadesExtras.length > 0) {
                  let actExtra = est.actividadesExtras.find(
                    (a) =>
                      a.actividadExtra?.ptevaInstrumento?.id ===
                        nota.ptevaInstrumento.id &&
                      a.actividadExtra.tipo === 'RECUPERACION' &&
                      a.actividadExtra.planEvaluacion.id === planEvaluacion?.id,
                  );

                  if (!actExtra) {
                    actExtra = est.actividadesExtras.find(
                      (a) =>
                        a.actividadExtra.tipo === 'REMEDIAL' &&
                        a.actividadExtra.planEvaluacion.id ===
                          planEvaluacion?.id,
                    );
                  }
                  actividadExtra = actExtra;
                } */
                }

                if (actividad) {
                  {
                    /* if (actividadExtra?.actividadExtra.tipo === 'REMEDIAL') {
                    totalDef = notaToPonderacionHelper(
                      parseInt(actividadExtra.nota),
                      actividadExtra.actividadExtra.ponderacion,
                      entidadesStore.ajustes.ponderacion,
                    );
                    return;
                  } */
                  }

                  totalDef += notaToPonderacionHelper(
                    parseInt(nota.nota),
                    actividad.ponderacion,
                    entidadesStore.ajustes.ponderacion,
                  );
                }
              });
            }

            return (
              est.estatus?.id === 1 && (
                <TableRow
                  sx={{
                    '&:hover': { backgroundColor: grey[200] },
                  }}
                >
                  <TableCell align="left">
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Avatar
                        alt={est.usuario.perfil.pnombre}
                        src={
                          est.usuario.perfil.avatar
                            ? getFilesArchivos(est.usuario.perfil.avatar)
                            : `static/images/${
                                est.usuario.perfil.gender
                                  ? 'userf.png'
                                  : 'userm.png'
                              }`
                        }
                        sx={{ width: 50, height: 50 }}
                      />
                      <Stack spacing={1} justifyContent="center">
                        <Typography variant="body1" color="initial">
                          {est.usuario.perfil.tipoDni}-{est.usuario.perfil.dni}
                        </Typography>
                        <Typography
                          variant="body1"
                          color="initial"
                          sx={{ fontWeight: 'bold' }}
                        >
                          {est.usuario.perfil.pnombre}{' '}
                          {est.usuario.perfil.papellido}
                        </Typography>
                      </Stack>
                    </Stack>
                  </TableCell>
                  {notasEvaluativasByPlan(est.notasEvaluativas).map(
                    (actividad) => celdasNotas(est.id, actividad),
                  )}
                  {actividadesExtrasByPlan(est.actividadesExtras).map(
                    (actividad) => celdasActividadExtra(actividad),
                  )}
                  <TableCell>
                    <Stack alignItems="center">
                      <Stack
                        sx={{
                          minWidth: '80px',
                        }}
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Typography aling="center" variant="caption1">
                          {totalDef.toFixed(2)}
                        </Typography>
                        <Typography aling="center" variant="caption1">
                          {notaToPonderacionHelper(
                            Math.round(totalDef),
                            100,
                            entidadesStore.ajustes.ponderacion,
                          ).toFixed(0)}
                          %
                        </Typography>
                      </Stack>
                      <Typography
                        aling="center"
                        sx={{
                          fontSize: '18pt',
                          fontWeight: 'bold',
                          color: notaHoverColor(Math.round(totalDef)),
                        }}
                      >
                        {totalDef < 10
                          ? '0' + Math.round(totalDef)
                          : Math.round(totalDef)}{' '}
                        <label
                          style={{
                            color: 'black',
                            fontWeight: 'normal',
                            fontSize: '12pt',
                          }}
                        >
                          Pts
                        </label>
                      </Typography>
                    </Stack>
                  </TableCell>
                  <TableCell width="70px">
                    <ActionsListWidget
                      id={est.id}
                      onCalcularNota={() => {
                        setEstudianteSelect(est);
                        dispatch({
                          type: CALCULADORA_NOTAS_EVALUATIVAS,
                          payload: {
                            estudiante: est,
                            actividades: actividadesArray,
                          },
                        });
                        setOpenModalForm(true);
                      }}
                      // onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                      // onDelete={() => {
                      //   const data = eventosStore.all.find(
                      //     (el) => el.id === tableMeta.rowData[0],
                      //   );
                      //   setActivoEventosAction(dispatch, data);
                      //   setOpenModalDelete(true);
                      // }}
                      // onDownload={() => {
                      //   window.open(value.url);
                      // }}
                    />
                  </TableCell>
                </TableRow>
              )
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget isLoading={estudiantesStore.loadingAll || loadingSave} />
        {planEvaluacionStore.all.length > 0 ? (
          <>
            {tablaChart}
            {tablaBody}
          </>
        ) : (
          <h4>No tienes planes de evaluacion asignados</h4>
        )}
      </Grid>
      {estudianteSelect && (
        <ModalComponent
          id="modalCalcularNotas"
          title="Calculadora de notas evaluativas"
          open={openModalForm}
          onClose={() => setOpenModalForm(!openModalForm)}
        >
          <CalculadoraNotasEstudianteView />
        </ModalComponent>
      )}
    </Grid>
  );
};

export default ListadoNotasEvaluativas;
